import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useFormUtility from "../utilities/useFormUtility";
import useHttpUtility from "../utilities/useHttpUtility";
import LoadingScreen from "../components/LoadingScreen"
import Table from "../components/Table";
import RuleSection from "../sections/RuleSection";
import MenuPage from "../components/MenuPage";
import MenuPageItemDiscard from "../components/MenuPageItemDiscard";
import MenuPageItemCopy from "../components/MenuPageItemCopy";
import MenuPageItemSave from "../components/MenuPageItemSave";
import MenuPageItemDelete from "../components/MenuPageItemDelete";
import FormFieldText from "../components/FormFieldText";
import FormFieldNumber from "../components/FormFieldNumber";
import FormFieldCheckbox from "../components/FormFieldCheckbox";

export default function PagePackageSize() {

    const navigate = useNavigate();
    const http = useHttpUtility();
    const formUtility = useFormUtility(null);

    const { id } = useParams();
    

    const [selectedIndexRule, setSelectedIndexRule] = useState(-1);
    
    useEffect(() => {
        if (!id || id === "0") {
            formUtility.setData({
                id: null,
                name: "",
                length: "",
                width: "",
                height: "",
                weight: "",
                sortOrder: "1",
                active: false,
                rules: []
            }, true);
        }
        else {
            http.get(`/api/PackageSizes/${id}`, formUtility.setData);
        }
    }, []);

    function handleOnOkRule(rule) {
        if (selectedIndexRule < 0 && selectedIndexRule !== -2)
            return;

        let rules = [...formUtility.data.rules];

        selectedIndexRule >= 0
            ? rules.splice(selectedIndexRule, 1, rule)
            : rules.push(rule);

        formUtility.handleChange([{ field: "rules", value: rules }]);
        setSelectedIndexRule(-1);
    }

    function handleOnRemoveRule(idx) {
        if (idx < 0)
            return;

        let rules = [...formUtility.data.rules];
        rules.splice(idx, 1);
        formUtility.handleChange([{ field: "rules", value: rules }]);
    }

    return (
        !formUtility.data
            ? <LoadingScreen />
            : 
                <div className="page page-package-size">
                    {
                        selectedIndexRule >= 0 || selectedIndexRule === -2
                        ? <RuleSection
                            data={selectedIndexRule === -2 ? null : formUtility.data.rules[selectedIndexRule]}
                            onDiscard={() => setSelectedIndexRule(-1)}
                            onOk={handleOnOkRule} />
                            :
                            <>
                                <MenuPage>
                                    <MenuPageItemDiscard formUtility={formUtility} onClick={() => navigate(`..${window.location.search}`)} />
                                    <MenuPageItemCopy
                                        formUtility={formUtility}   
                                        onClick={() => {
                                            var newData = {
                                                ...formUtility.data,
                                                id: null,
                                                name: "",
                                                rules: formUtility.data.rules.map(r => ({ ...r, id: null }))
                                            };
                                            formUtility.setData(newData, true);
                                        }} />
                                    <MenuPageItemSave formUtility={formUtility} onClick={() => http.post(`/api/PackageSizes/${formUtility.data.id ? "Update" : "Create"}`, formUtility.data, formUtility.setData)} />
                                    <MenuPageItemDelete formUtility={formUtility} onClick={() => http.delete(`/api/PackageSizes/${formUtility.data.id}`, () => navigate(`..${window.location.search}`))} />
                                </MenuPage>
                                <FormFieldText formUtility={formUtility} field="name" label="Name" max="30" />
                                <FormFieldNumber formUtility={formUtility} field="length" label="Length (cm)" />
                                <FormFieldNumber formUtility={formUtility} field="width" label="Width (cm)" />
                                <FormFieldNumber formUtility={formUtility} field="height" label="Height (cm)" />
                                <FormFieldNumber formUtility={formUtility} field="weight" label="Weight (kg)" />
                                <FormFieldNumber formUtility={formUtility} field="sortOrder" label="Sort Order" integerOnly={true} />
                                <FormFieldCheckbox formUtility={formUtility} field="active"  label="Active" />
                                <br />
                                <h2>Rules</h2>
                                <p>Allows you to set up user defined rules that tell the cart when to offer the rate, or when not to offer the rate.</p>
                                <Table
                                    formUtility={formUtility}
                                    data={formUtility.data.rules}
                                    mappings={
                                        [
                                            {
                                                header: "Type",
                                                field: "ruleType",
                                                dataType: "ruleType"
                                            },
                                            {
                                                header: "Condition",
                                                field: "condition",
                                                dataType: "condition"
                                            },
                                            {
                                                header: "Value",
                                                field: "value"
                                            },
                                            {
                                                header: "Or Group",
                                                field: "orGroup"
                                            }
                                        ]
                                    }
                                    onClickAdd={() => setSelectedIndexRule(-2)}
                                    onClick={setSelectedIndexRule}
                                    onRemove={handleOnRemoveRule}
                                />
                            </>
                    }
                </div>
    );
}